/**
 * Escapes JSON string for safe embedding inside a <script type="application/json"> tag
 * to prevent script injection (e.g. </script> in string values).
 */

/** Literal backslash-u sequences so JSON parse on client yields the original character. */
const LT_ESC = '\\u003c';   // <
const GT_ESC = '\\u003e';   // >
const AMP_ESC = '\\u0026';  // &

/**
 * Escapes a string so it can be safely embedded in an HTML script body.
 * Replaces < with \u003c (six characters) to prevent breaking out of the script tag.
 */
export function escapeForHtmlScript(str: string): string {
  return str
    .replace(/</g, LT_ESC)
    .replace(/>/g, GT_ESC)
    .replace(/&/g, AMP_ESC);
}

/**
 * Serializes a JSON-serializable value to a string safe for embedding in
 * <script id="srp-initial" type="application/json">...</script>.
 * Uses JSON.stringify then escapes the result so that </script> in any
 * string value cannot break out of the tag.
 */
export function serializeForHtmlScript(json: unknown): string {
  const raw = JSON.stringify(json);
  return escapeForHtmlScript(raw);
}
